import { Checkbox, FormControlLabel } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  fetchCatalogFilters,
  fetchPageNumberTotal,
  fetchProductsAllWithPagination,
  fetchProductsByFilters,
} from "../actions/global";
import { useLocation, useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from "./Reusable/Loader";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import globalActions from "../reducers/globalActions";

const CatalogFiltersList = ({
  categoryId,
  loadingFilterList,
  dataCatalogFiltersList,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // Stanje za praćenje otvaranja/zatvaranja svake komponente
  const [isOpen, setIsOpen] = useState("");

  const handleToggle = (naziv) => {
    // Ažuriranje stanja za trenutnu komponentu
    setIsOpen((prevState) => ({
      ...prevState,
      [naziv]: !prevState[naziv],
    }));
  };

  const handleCheckboxChange = (event, id) => {
    const searchParams = new URLSearchParams(location.search);
    let filters = searchParams.get("filters")?.split(",") || [];

    if (event.target.checked) {
      // Dodaj ID ako ga nema
      if (!filters.includes(id)) {
        filters.push(id);
      }
    } else {
      // Ukloni ID ako postoji
      filters = filters.filter((f) => f !== id);
    }

    // Ako nema više filtera, brišemo parametar
    if (filters.length > 0) {
      searchParams.set("filters", filters.join(","));
    } else {
      searchParams.delete("filters");
    }

    // Resetujemo paginaciju na 1 kad se promeni filter
    searchParams.set("page", 0);

    navigate(`${location.pathname}?${searchParams.toString()}`);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const filters = searchParams.get("filters");

    const page = searchParams.get("page") || 0;
    const size = 12;
    const sort = searchParams.get("sort");
    const asc = searchParams.get("asc");

    // dispatch(globalActions.dataCatalogFiltersClear());
    dispatch(fetchProductsByFilters(filters, categoryId, { page, size, asc }));
  }, [location.search, dispatch, categoryId]);

  return (
    <>
      <div className="filter-actions">
        <label>Filteri:</label>
        <a
          // onClick={() => functionResetFilters(1)}
          className="btn btn-dark btn-link filter-clean"
        >
          Obriši sve
        </a>
      </div>
      <div className="button-submit-filter-mobile ">
        <button
          className="btn btn-primary btn-rounded w-100"
          // onClick={() => closeSidebarFilter()}
        >
          Primeni odabrane filtere
        </button>
      </div>
      {loadingFilterList ? (
        <Loader />
      ) : (
        <>
          {Object.keys(dataCatalogFiltersList).length > 0 ? (
            <>
              {Object.entries(dataCatalogFiltersList).map(
                ([naziv, vrednosti]) => (
                  <div className="widget widget-collapsible" key={naziv}>
                    <h3
                      className={`widget-title ${
                        isOpen[naziv] ? "collapsed" : ""
                      }`}
                      onClick={() => handleToggle(naziv)}
                    >
                      <span>{naziv}</span>
                      <span className="toggle-btn"></span>
                    </h3>
                    <ul
                      className={`widget-body item-check mt-1 ${
                        isOpen[naziv] ? "collapsed" : ""
                      }`}
                    >
                      {vrednosti?.map((item) => (
                        <li key={item.id} className="custom-title-name-filter">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  new URLSearchParams(location.search)
                                    .get("filters")
                                    ?.split(",")
                                    .includes(item.id) || false
                                }
                                onChange={(event) =>
                                  handleCheckboxChange(event, item.id)
                                }
                              />
                            }
                            label={item.value}
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                )
              )}
            </>
          ) : (
            <div className="alert alert-icon alert-primary alert-bg alert-inline show-code-action">
              <h4 className="alert-title">
                <FontAwesomeIcon icon={faInfoCircle} />
              </h4>{" "}
              Ne postoje filteri
            </div>
          )}
        </>
      )}
    </>
  );
};

export default CatalogFiltersList;
